import React from 'react';

export const PublisherMicrodataSchema = ({sameAsLinks = []}) => {
  const publisherContainerProps = {
    itemScope: true,
    itemProp: 'publisher',
    itemType: "https://schema.org/Organization",
    itemID: "https://www.365scores.com/#organization",
  }

  return (
    <div {...publisherContainerProps}>
      <meta itemProp="name" content={"365Scores"}/>
      <meta itemProp="url" content={"https://www.365scores.com/"}/>
      {
        sameAsLinks?.map((link, index) => <meta key={index} itemProp="sameAs" content={link}/>)
      }
      <div itemProp="logo" itemScope itemType={"https://schema.org/ImageObject"}>
        <meta itemProp="url" content={"https://imagecache.365scores.com/image/upload/f_png,q_auto:eco,dpr_1/WebSite/logo_wide_new"}/>
        <meta itemProp="width" content={"198"}/>
        <meta itemProp="height" content={"104"}/>
        <meta itemProp="caption" content={"365scores logo"}/>
      </div>
    </div>
  );
};